import { api } from './client';
import type {
  CampaignWithMembers,
  CampaignWithMembersAndCharacters,
  CreateCampaignRequest,
  CampaignMember,
  InviteResponse,
  PendingInvite,
} from '@charbuilder/shared';

export async function getCampaigns(): Promise<CampaignWithMembers[]> {
  const res = await api.get<CampaignWithMembers[]>('/campaigns');
  return res.data;
}

export async function getCampaign(id: string): Promise<CampaignWithMembersAndCharacters> {
  const res = await api.get<CampaignWithMembersAndCharacters>(`/campaigns/${id}`);
  return res.data;
}

export async function createCampaign(data: CreateCampaignRequest): Promise<CampaignWithMembers> {
  const res = await api.post<CampaignWithMembers>('/campaigns', data);
  return res.data;
}

export async function updateCampaign(id: string, data: Partial<CreateCampaignRequest>): Promise<CampaignWithMembers> {
  const res = await api.patch<CampaignWithMembers>(`/campaigns/${id}`, data);
  return res.data;
}

export async function deleteCampaign(id: string): Promise<void> {
  await api.delete(`/campaigns/${id}`);
}

export async function invitePlayer(campaignId: string, username: string): Promise<CampaignMember> {
  const res = await api.post<CampaignMember>(`/campaigns/${campaignId}/invite`, { username });
  return res.data;
}

export async function respondToInvite(campaignId: string, status: 'ACCEPTED' | 'DECLINED'): Promise<InviteResponse> {
  const res = await api.patch<InviteResponse>(`/campaigns/${campaignId}/invite/respond`, { status });
  return res.data;
}

export async function getPendingInvites(): Promise<PendingInvite[]> {
  const res = await api.get<PendingInvite[]>('/campaigns/invites');
  return res.data;
}
